import React from "react";

const Education = () => {
  return (
    <div className="container mx-auto px-4 mt-20">
      <div className="flex lg:flex-row flex-col w-full">
        <div className="md:mx-10 mx-3">
          <h2 className="text-2xl font-bold text-gray_dark mb-10">Education Quality</h2>
          <div className="educationSide ">
          <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark md:text-2xl text-xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div className=""> 
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">4.30/5</span>
                </div> 
                </div>
                <hr className="my-8"/>
                <p className="text-gray_dark text-lg">
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
          <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark text-2xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div>
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">

                    4.30/5
                    </span>
                    </div>
                </div>
                <hr className="my-8"/>

                <p>
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
          <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark text-2xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div>
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">

                    4.30/5
                    </span>
                    </div>
                </div>
                <hr className="my-8"/>

                <p>
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
            
          </div>
        </div>



        <div className="md:mx-10 mx-3">
          <h2 className="text-2xl font-bold text-gray_dark mb-10">Education Quality</h2>
            <div className="educationQuality">
            <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark text-2xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div>
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">
                    4.30/5
                    </span>
                    </div>
                </div>
                <hr className="my-8"/>

                <p>
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
            <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark text-2xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div>
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">
                    4.30/5
                    </span>
                    </div>
                </div>
                <hr className="my-8"/>

                <p>
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
            <div className="cardResume">
              <div className="flex justify-between md:flex-row flex-col">
                <div className="mb-4">
                  <h3 className="text-light_dark text-2xl font-medium mb-1">Personal Portfolio April Fools</h3>
                  <span>University of DVI (1997 - 2001)</span>
                </div>
                <div>
                    <span className="bg-light_white shadow-lg px-6 py-2 rounded-md font-medium text-sweet_red">
                    4.30/5
                    </span>
                    </div>
                </div>
                <hr className="my-8"/>

                <p>
                  The education should be very interactual. Ut tincidunt est ac
                  dolor aliquam sodales. Phasellus sed mauris hendrerit, laoreet
                  sem in, lobortis mauris hendrerit ante.
                </p>
              
            </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
